<template>
  <div class="schlieren-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>n = f(ρ) | 气体密度可视化$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Mirror Circle (Viewing Window) -->
          <circle cx="200" cy="120" r="90" fill="#111" stroke="#444" stroke-width="2" />
          
          <!-- Heat source (Candle/Component) -->
          <rect x="195" y="150" width="10" height="30" fill="#555" />
          <path v-if="active" d="M 195,150 Q 200,120 205,150" fill="#ff4757" opacity="0.6">
             <animate attributeName="d" values="M 195,150 Q 200,120 205,150; M 195,150 Q 210,120 205,150; M 195,150 Q 200,120 205,150" dur="1s" repeatCount="indefinite" />
          </path>

          <!-- Schlieren Waves (Density gradients) -->
          <g v-if="active">
             <path v-for="i in 5" :key="i" :d="calcWave(i)" fill="none" :stroke="`rgba(255,255,255,${0.1 - i*0.02})`" stroke-width="4" />
          </g>

          <!-- Knife Edge -->
          <rect x="300" y="40" width="5" height="160" fill="#888" />
          <text x="310" y="120" fill="#888" font-size="8">刀口 (遮挡部分光线)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ active ? '气流干扰可见' : '无密度梯度' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="warning" size="mini" @click="active = !active">{{ active ? '关闭热源' : '开启热源 (观察扰动)' }}</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>纹影法是一种利用**折射率梯度**拍摄气流透明分布的精密光学技术。当空气密度不均时（如由于受热或超音速波），光线穿过时会发生微小偏转。通过在成像系统的焦点处设置一个刀口遮挡掉偏转的光线，就能在屏幕上显现出空气扰动的明暗阴影。它被广泛用于风洞测试和爆炸物理研究。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchlierenViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      active: true,
      time: 0
    }
  },
  methods: {
    calcWave(i) {
       let xOffset = Math.sin(this.time + i) * 10;
       return `M 200,150 Q ${200 + xOffset}, ${150 - i*20} ${200 + xOffset*0.5}, ${50}`;
    },
    update() {
       this.time += 0.05;
       requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.schlieren-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
